import { render, staticRenderFns } from "./v-main-header-menu.vue?vue&type=template&id=6b4223e3&scoped=true"
import script from "./v-main-header-menu.vue?vue&type=script&lang=js"
export * from "./v-main-header-menu.vue?vue&type=script&lang=js"
import style0 from "./v-main-header-menu.vue?vue&type=style&index=0&id=6b4223e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4223e3",
  null
  
)

export default component.exports